// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-modal .spinner {
  display: none;
}
.editor-modal .modal-error {
  display: none;
}

.editor-file-upload label {
  font-weight: bold;
}
.editor-file-upload .or-separator {
  padding: 10px 0;
  font-style: italic;
  text-align: center;
}
.editor-file-upload input[type=text] {
  display: block;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/markdown/markdown-editor.scss"],"names":[],"mappings":"AACC;EACC,aAAA;AAAF;AAGC;EACC,aAAA;AADF;;AAMC;EACC,iBAAA;AAHF;AAKC;EACC,eAAA;EACA,kBAAA;EACA,kBAAA;AAHF;AAKC;EACC,cAAA;EACA,WAAA;AAHF","sourcesContent":[".editor-modal {\n\t.spinner {\n\t\tdisplay: none;\n\t}\n\n\t.modal-error {\n\t\tdisplay: none;\n\t}\n}\n\n.editor-file-upload {\n\tlabel {\n\t\tfont-weight: bold;\n\t}\n\t.or-separator {\n\t\tpadding: 10px 0;\n\t\tfont-style: italic;\n\t\ttext-align: center;\n\t}\n\tinput[type=text] {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
